import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["meetingLink"];
import { CreateAndRedirectButton } from '../shared/CreateAndRedirectButton';
import { jsx as _jsx } from "react/jsx-runtime";
const MEETINGS_TEMPLATE = '@hubspot/calls-to-action/templates/meeting-popup.html';
export function CreateMeetingPopupButton(_ref) {
  let {
      meetingLink
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CreateAndRedirectButton, Object.assign({
    template: MEETINGS_TEMPLATE,
    redirectQueryParams: {
      insertMeetingLink: meetingLink
    }
  }, rest));
}